// Toggle panel submenu (hamburger mở/đóng) — hành vi riêng của trang, không phải hook MJ__ của lib.
// $ là jQuery global do libraryMainsite CDN nạp (không import).
$(document).on('click', '#header .js-toggle-submenu', function (e) {
  e.preventDefault();
  $('#header').toggleClass('submenu-active');
  // Mở/đóng panel làm đổi chiều cao DOM -> báo lib remeasure (lib chỉ tính lại scale + height ở `resize`).
  window.dispatchEvent(new Event('resize'));
});
